/** Shared helpers for journey date filters → API query params. */

/** Shown on Funnel/Paths when the page is on live API data. */
export const LIVE_DATA_SOURCE_LABEL = 'Venue Intelligence';

function toIsoDate(date) {
  return date.toISOString().slice(0, 10);
}

/** Map season filter values to inclusive start/end dates. */
export function seasonToDateRange(season, now = new Date()) {
  if (season === '2024-25') {
    return { start: '2024-08-01', end: '2025-07-31' };
  }
  if (season === '2025-26') {
    return { start: '2025-08-01', end: toIsoDate(now) };
  }
  // Broad window covering local demo seed (2021 → present).
  return { start: '2021-09-01', end: toIsoDate(now) };
}

/** UI filter value → numeric API id (or null for "all" / mock slugs). */
export function resolveNumericFilter(value) {
  if (value == null || value === '' || value === 'all') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Build /funnel and /paths query filters from journey UI state.
 * Venue/event must be numeric ids from GET /api/filters.
 */
export function buildJourneyApiFilters({
  season,
  accountId = null,
  eventId = null,
  venueId = null,
  venue = null,
  event = null,
} = {}) {
  const range = seasonToDateRange(season);
  return {
    start: range.start,
    end: range.end,
    accountId: accountId || undefined,
    eventId: resolveNumericFilter(eventId ?? event) || undefined,
    venueId: resolveNumericFilter(venueId ?? venue) || undefined,
  };
}
